import { useState, useEffect } from "react";
import { getMajorStocks } from "@/lib/api";
import { TrendingUp, TrendingDown, Gauge } from "lucide-react";

const SPEED_KEY = "rj_ticker_speed";
const BASE_SECONDS_PER_STOCK = 4;

export default function MarketTicker() {
  const [stocks, setStocks] = useState([]);
  const [speed, setSpeed] = useState(() => Number(localStorage.getItem(SPEED_KEY)) || 1);
  const changeSpeed = (v) => { setSpeed(v); localStorage.setItem(SPEED_KEY, String(v)); };

  useEffect(() => {
    const fetch = () => getMajorStocks().then(r => setStocks((r.data || []).filter(s => s.price != null))).catch(() => {});
    fetch();
    const interval = setInterval(fetch, 60000);
    return () => clearInterval(interval);
  }, []);

  if (stocks.length === 0) return null;

  const doubled = [...stocks, ...stocks];

  return (
    <div className="max-w-[1600px] mx-auto px-3 sm:px-4 md:px-8 pt-4 flex items-stretch gap-0" data-testid="market-ticker">
      <div
        className="ticker-container flex-1 min-w-0 bg-bt-surface border border-bt-border-subtle py-2 px-3"
        style={{ maskImage: "linear-gradient(to right, transparent, black 24px, black calc(100% - 24px), transparent)", WebkitMaskImage: "linear-gradient(to right, transparent, black 24px, black calc(100% - 24px), transparent)" }}
        data-testid="market-ticker-track"
      >
      <div className="ticker-content" style={{ animationDuration: `${Math.max(60, stocks.length * BASE_SECONDS_PER_STOCK) / speed}s` }}>
        {doubled.map((s, i) => (
          <div key={`${s.symbol}-${i}`} className="flex items-center gap-2 shrink-0">
            <span className="font-mono text-xs font-medium text-bt-text-primary">{s.symbol}</span>
            <span className="font-mono text-xs text-bt-text-secondary">${s.price.toLocaleString()}</span>
            <span className={`font-mono text-xs flex items-center gap-0.5 ${s.change_pct >= 0 ? "text-bt-positive" : "text-bt-negative"}`}>
              {s.change_pct >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              {s.change_pct >= 0 ? "+" : ""}{s.change_pct}%
            </span>
          </div>
        ))}
      </div>
      </div>
      <label className="flex items-center gap-1.5 px-2 bg-bt-surface border border-l-0 border-bt-border-subtle shrink-0" title={`Ticker speed: ${speed}×`}>
        <Gauge className="hidden sm:block w-3 h-3 text-bt-text-tertiary" />
        <input type="range" min={0.25} max={2} step={0.25} value={speed} onChange={(e) => changeSpeed(Number(e.target.value))}
          className="w-10 sm:w-14 h-1 cursor-pointer accent-[rgb(var(--bt-gold))]" aria-label="Ticker speed" data-testid="ticker-speed-slider" />
        <span className="hidden sm:inline font-mono text-[9px] text-bt-text-tertiary w-7" data-testid="ticker-speed-value">{speed}×</span>
      </label>
    </div>
  );
}
